import React from 'react';
import PropTypes from 'prop-types';

import EmptyListing from 'src/components/EmptyListing/EmptyListing';
import 'src/components/EmptyListing/BasicEmptyListing.scss';


const BasicEmptyListing = function ({
  header,
  copy,
  hint,
  imageSource,
  imageType
}) {
  const image = (
    <img alt="" aria-hidden="true" src={ imageSource } styleName="image" width="405" height="220" />
  );
  const footer = (
    <>
      <p styleName="hint">{hint}</p>
      {copy}
    </>
  );

  return (
    <EmptyListing
      footer={ footer }
      header={ header }
      image={ image }
      imageType={ imageType }
    />
  );
};

BasicEmptyListing.defaultProps = {
  imageType: 'normal'
};

BasicEmptyListing.propTypes = {
  copy: PropTypes.node.isRequired,
  header: PropTypes.string.isRequired,
  hint: PropTypes.string.isRequired,
  imageSource: PropTypes.string.isRequired,
  imageType: PropTypes.oneOf(['normal', 'wide'])
};

export default BasicEmptyListing;
